export interface TrendItem {
  id: string
  geo: string
  category: string
  trendScore: number
  quantity?: number
  websearch_query: string
  summary: string
  sources: { title: string; url: string }[]
  current_timestamp?: number
}

export interface TrendsResponse {
  items: TrendItem[]
  last_evaluated_key?: any
}

import { api } from '@/utils/api'

export async function fetchTrends(params: {
  geo?: string
  category?: string
  minScore?: number
  limit?: number
  lastKey?: any
}, options: { signal?: AbortSignal } = {}): Promise<TrendsResponse> {
  const q = new URLSearchParams()
  if (params.geo) q.set('geo', params.geo)
  if (params.category) q.set('category', params.category)
  if (params.minScore != null) q.set('min_score', String(params.minScore))
  if (params.limit != null) q.set('limit', String(params.limit))
  if (params.lastKey) q.set('last_evaluated_key', JSON.stringify(params.lastKey))

  return api.get(`/v0_1/global_trends/global?${q.toString()}`, { signal: options.signal })
}

export async function fetchTrendCategories(params: { geo?: string } = {}, options: { signal?: AbortSignal } = {}): Promise<{ categories: string[] }> {
  const q = new URLSearchParams()
  if (params.geo) q.set('geo', params.geo)
  return api.get(`/v0_1/global_trends/categories?${q.toString()}`, { signal: options.signal })
}

export async function saveTrendCard(payload: Partial<TrendItem>) {
  return api.post(`/v0_1/global_trends/save`, payload)
}

export async function fetchSavedTrends(params: { limit?: number; lastKey?: any } = {}) {
  const q = new URLSearchParams()
  if (params.limit != null) q.set('limit', String(params.limit))
  if (params.lastKey) q.set('last_evaluated_key', JSON.stringify(params.lastKey))
  return api.get(`/v0_1/global_trends/saves?${q.toString()}`)
}

export async function deleteSavedTrend(save_id: string) {
  return api.delete(`/v0_1/global_trends/saves/${save_id}`)
}


